import PropTypes from 'prop-types';
import sty from '../../WebCv/WebCv.module.css';

const Profile = ({ data }) => {

    // props
    Profile.propTypes = {
        data: PropTypes.object.isRequired,
    };

    if (!data) {
        return <div>プロフィールデータがありません</div>;
    }

    // 表示チェック
    // const setList = (speciality) => {
    //     if (speciality) {
    //         const specialitys = speciality.split('、');
    //         let lists = '';
    //         for (let i = 0; i < specialitys.length; i++) {
    //             lists += `・${specialitys[i]}\n`;
    //         }
    //         return lists;
    //     }
    // }

    return (
        <div>
            <div className={sty['cv__profile']}>
                <dl className={sty['cv__profile-list']}>
                    <dt className={sty['cv__profile-list-tit']}>経歴概要</dt>
                    <dd className={sty['cv__profile-list-txt']}>
                        {data?.input?.career_overview}
                    </dd>
                    <dt className={sty['cv__profile-list-tit']}>得意分野</dt>
                    <dd className={sty['cv__profile-list-txt']}>
                        {data?.input?.speciality}
                    </dd>
                    <dt className={sty['cv__profile-list-tit']}>今後の方向性</dt>
                    <dd className={sty['cv__profile-list-txt']}>
                        {data?.input?.future_direction}
                    </dd>
                </dl>
            </div>
        </div>
    )
}

export default Profile;